<template>
  <video-boost-statistics mode="account"></video-boost-statistics>
</template>

<script>
import VideoBoostStatistics from './VideoBoostStatistics.vue'

export default {
  name: 'VideoBoostAccountStats',
  components: {VideoBoostStatistics}
}
</script>
